import React from 'react';
import styled from 'styled-components'
import { Container, Grid } from 'semantic-ui-react'

const Styles = styled.div`
    .about-hero {
        background: var(--gradient-primary);
        min-height: 60vh;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        padding: 4rem 2rem;
    }

    .about-hero::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(circle at 30% 50%, rgba(0, 217, 255, 0.15) 0%, transparent 50%);
    }

    .about-content {
        position: relative;
        z-index: 1;
        max-width: 800px;
        margin: 0 auto;
        background: linear-gradient(135deg, rgba(26, 31, 58, 0.8) 0%, rgba(42, 47, 74, 0.6) 100%);
        backdrop-filter: blur(10px);
        border-radius: 24px;
        padding: 3rem;
        border: 1px solid rgba(255, 255, 255, 0.1);
    }

    .about-title {
        font-family: 'Syne', sans-serif;
        font-size: 3rem;
        font-weight: 800;
        color: var(--color-text);
        margin-bottom: 1.5rem;
    }

    .about-subtitle {
        font-family: 'IBM Plex Sans', sans-serif;
        font-size: 1.3rem;
        font-weight: 400;
        color: var(--color-text);
        line-height: 1.6;
        margin-bottom: 1.5rem;
    }

    .about-text {
        font-family: 'IBM Plex Sans', sans-serif;
        font-size: 1.1rem;
        color: var(--color-text-muted);
        line-height: 1.7;
    }

    .contact-section {
        background: rgba(10, 14, 39, 0.5);
        padding: 4rem 2rem;
    }

    .contact-info {
        font-family: 'IBM Plex Sans', sans-serif;
        font-size: 1.1rem;
        color: var(--color-text-muted);
        line-height: 1.8;
    }

    .contact-info a {
        color: var(--color-accent);
        text-decoration: none;
        transition: color 0.3s ease;
    }

    .contact-info a:hover {
        color: #66E5FF;
    }
`

function About() {
    return (
        <Styles>
            <div className="about-hero">
                <Container>
                    <div className="about-content">
                        <h1 className="about-title">About Yay Fun</h1>
                        <h3 className="about-subtitle">
                            Located in Northwest Austin, Texas. We design, develop, and maintain
                            software products for ourselves and our clients.
                        </h3>
                        <p className="about-text">
                            Yay Fun, Inc. is committed to building exceptional user experiences through
                            modern technology stacks and proven engineering practices. With over a decade
                            of experience in web and mobile development, we specialize in creating scalable
                            platforms that solve real business problems.
                        </p>
                    </div>
                </Container>
            </div>

            <div className="contact-section">
                <Container>
                    <Grid stackable>
                        <Grid.Row>
                            <Grid.Column width={8}>
                                <h2 style={{
                                    fontFamily: 'Syne, sans-serif',
                                    fontSize: '2rem',
                                    color: 'var(--color-text)',
                                    marginBottom: '1.5rem'
                                }}>
                                    Get in Touch
                                </h2>
                                <div className="contact-info">
                                    <p>
                                        Yay Fun, Inc.<br />
                                        3616 Far West Blvd 117-414<br />
                                        Austin, TX 78731<br />
                                        <a href="tel:5127295122">(512) 729-5122</a>
                                    </p>
                                </div>
                            </Grid.Column>
                            <Grid.Column width={8}>
                                <h2 style={{
                                    fontFamily: 'Syne, sans-serif',
                                    fontSize: '2rem',
                                    color: 'var(--color-text)',
                                    marginBottom: '1.5rem'
                                }}>
                                    Our Products
                                </h2>
                                <div className="contact-info">
                                    <p>
                                        <a href="https://pokeswift.com" target="_blank" rel="noopener noreferrer">
                                            PokeSwift.com
                                        </a> - TCG Marketplace Platform<br /><br />
                                        <a href="https://socialbellow.com" target="_blank" rel="noopener noreferrer">
                                            SocialBellow.com
                                        </a> - Social Media Management
                                    </p>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Container>
            </div>
        </Styles>
    )
}

export default About
